module.exports = __webpack_public_path__ + "media/images/tap-3583c92479515a5e1800f296c976c3da.svg";